const MetricConfig = {
  GrowthMetric: {
    tabIndex: 0,
    name: "Growth",
    chartType: "line",
    enabled: true,
    hideOnSchoolView: false,
  },
  UsageMetric: {
    tabIndex: 1,
    name: "Usage",
    chartType: "bar",
    enabled: true,
    hideOnSchoolView: false,
  },
  DemographicsMetric: {
    tabIndex: 2,
    name: "Demographics",
    chartType: "stackedBar",
    enabled: false,
    hideOnSchoolView: true,
  },
};
const getMetricKeyForTab = (tabIndex) => {
  const key = Object.entries(MetricConfig).find(
    ([, config]) => config.tabIndex === tabIndex && config.enabled,
  );

  return key ? key[0] : null;
};

export { MetricConfig, getMetricKeyForTab };
